import { Skeleton } from "@/components/kit";
import type { CustomerProductAffinityResultDTO } from "@/modules/reports/domain/types";
import { formatLak } from "@/shared/lib/currency";

type CustomerAffinityTableProps = {
  result?: CustomerProductAffinityResultDTO;
  isLoading?: boolean;
};

export function CustomerAffinityTable({
  result,
  isLoading,
}: CustomerAffinityTableProps) {
  if (isLoading) {
    return <Skeleton className="h-48 w-full rounded-2xl" />;
  }

  const rows = result?.data ?? [];

  if (rows.length === 0) {
    return null;
  }

  return (
    <div className="brand-card hidden overflow-x-auto p-4 sm:block sm:p-5">
      <h3 className="mb-3 font-medium text-sm">ລາຍລະອຽດ</h3>
      <table className="w-full min-w-[520px] text-sm">
        <thead>
          <tr className="border-border border-b text-left text-muted-foreground text-xs">
            <th className="pb-2 font-medium">ສິນຄ້າ</th>
            <th className="pb-2 text-right font-medium">ລູກຄ້າຊື້ຊ້ຳ</th>
            <th className="pb-2 text-right font-medium">ອໍເດີ້</th>
            <th className="pb-2 text-right font-medium">ຈຳນວນ</th>
            <th className="pb-2 text-right font-medium">ຍອດ</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={row.variantId}
              className="border-border/60 border-b last:border-0"
            >
              <td className="py-2 pr-3">
                <div className="font-medium">{row.productName}</div>
                {row.variantName ? (
                  <div className="text-muted-foreground text-xs">
                    {row.variantName}
                  </div>
                ) : null}
              </td>
              <td className="py-2 text-right tabular-nums">
                {row.returningCustomerCount}
              </td>
              <td className="py-2 text-right tabular-nums">{row.orderCount}</td>
              <td className="py-2 text-right tabular-nums">
                {row.quantity} {row.stockUnitLabel}
              </td>
              <td className="py-2 text-right tabular-nums">
                {formatLak(row.revenue)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
